import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';
import { Row, Col, Spin } from 'antd';

import { AppStore, IntegrationStore } from 'stores';
import { ContactLink } from 'v3/components/pitstop';
import Ggeotab from 'v3/assets/geotab.png';
import Samsara from 'v3/assets/samsara.png';

const Container = styled.div`
  padding-right: 2vw;

  h1 {
    font-size: 2.8rem;
    font-weight: 600;
    color: #000000;
  }

  p {
    font-weight: 400;
    color: #8c8c8c;
    opacity: 0.9;
  }

  label {
    font-weight: 600;
    display: block;
  }

  input {
    margin: 1.4vh 0vh;
  }
`;

const DashLine = styled.div`
  opacity: 0.2;
  border-top: 2px dashed #000000;
`;

const ConnectButton = styled.button`
  cursor: pointer;
  border: none;
  background: #02103d;
  border-radius: 5px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  color: #ffffff;
  height: 3rem;
  min-width: 8rem;

  a {
    color: #ffffff;
  }

  &:disabled {
    background: #c4c4c4;
    cursor: not-allowed;
  }
`;

const Img1 = styled.img`
  height: 15vh;
  background: #ffffff;
  box-shadow:
    0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  border: ${(props) => (props.$isSelected ? '2px solid #02103d' : 'none')};
  cursor: pointer;
  max-width: 100%;
  max-height: 100%;
  filter: grayscale(1);

  &.selected {
    filter: grayscale(0);
  }
`;

const OtherTelematic = styled.div`
  height: 5vh;
  background: #ffffff;
  box-shadow:
    0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 6px 16px rgba(0, 0, 0, 0.08),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  border: ${(props) => (props.$isSelected ? '2px solid #02103d' : 'none')};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;

  p {
    color: #000000;
    margin: 0;

    span {
      font-weight: 600;
    }
  }
`;

const Onboarding = ({ isUserLogin, history }) => {
  const [state, setState] = useState({
    isSelectedDemoData: false,
    isGeotabSelected: false,
    isSamsaraSelected: false,
    isOtherSelected: false,
    email: null,
    password: null,
    isSubmitted: false,
  });

  const setIntegrationType = () => {
    const { isGeotabSelected, isSamsaraSelected, isOtherSelected } = state;

    if (isGeotabSelected) {
      IntegrationStore.modalIntegrationForm = 'geotab-integration-form';
    }

    if (isSamsaraSelected) {
      IntegrationStore.modalIntegrationForm = 'samsara-integration-form';
    }

    if (isOtherSelected) {
      IntegrationStore.modalIntegrationForm = 'other-integration-form';
    }

    if (_.isNil(IntegrationStore.modalIntegrationForm)) {
      AppStore.addWarning('Please select your favor integration!');
      return;
    }

    history.push('/');
  };

  const onSelectDemoData = () => {
    if (state.isSelectedDemoData) return;
    setState(
      (prev) => ({
        ...prev,
        isSelectedDemoData: true,
      }),
      () => {
        IntegrationStore.modalIntegrationForm = 'demo-data';
        history.push('/');
      }
    );
  };

  const {
    isGeotabSelected,
    isSamsaraSelected,
    isOtherSelected,
    isSelectedDemoData,
  } = state;

  return (
    <Container id="register-form">
      <Row gutter={[16, 16]}>
        <Col>
          <h1>Connect Your Fleet</h1>
        </Col>

        <Col>
          <p>
            Connect your fleet with Pitstop by log in with Geotab, Samsara and
            many more !
          </p>
          <DashLine />
        </Col>

        <Col xs={12} style={{ margin: '3vh 0vh' }}>
          <Img1
            src={Ggeotab}
            alt="geotab"
            $isSelected={isGeotabSelected}
            onClick={() =>
              setState((prev) => ({
                ...prev,
                isGeotabSelected: !isGeotabSelected,
                isSamsaraSelected: false,
                isOtherSelected: false,
              }))
            }
            className={isGeotabSelected ? 'selected' : ''}
          />
        </Col>

        <Col xs={12} style={{ margin: '3vh 0vh' }}>
          <Img1
            src={Samsara}
            alt="samsara"
            $isSelected={isSamsaraSelected}
            onClick={() =>
              setState((prev) => ({
                ...prev,
                isSamsaraSelected: !isSamsaraSelected,
                isGeotabSelected: false,
                isOtherSelected: false,
              }))
            }
            className={isSamsaraSelected ? 'selected' : ''}
          />
        </Col>

        <Col span={24} style={{ display: 'flex' }}>
          <OtherTelematic $isSelected={isOtherSelected}>
            <p
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  isOtherSelected: !isOtherSelected,
                  isGeotabSelected: false,
                  isSamsaraSelected: false,
                }))
              }
            >
              Choose other <span>telematic integrations</span>
            </p>
          </OtherTelematic>
        </Col>

        <Col span={24} style={{ display: 'flex', marginTop: 10 }}>
          {isSelectedDemoData && <Spin style={{ marginRight: '0.6rem' }} />}
          <p
            style={{
              color: isSelectedDemoData ? 'grey' : '#000000',
              cursor: 'pointer',
            }}
            onClick={onSelectDemoData}
          >
            Explore Pitstop with{' '}
            <span
              style={{
                color: isSelectedDemoData ? 'grey' : '#000000',
                fontWeight: 600,
                textDecoration: 'underline',
              }}
            >
              Demo Data
            </span>
          </p>
        </Col>

        <Col span={24}>
          <ConnectButton
            disabled={
              !isGeotabSelected && !isSamsaraSelected && !isOtherSelected
            }
            onClick={setIntegrationType}
          >
            Connect
          </ConnectButton>
        </Col>

        <Col span={24} style={{ marginTop: 150 }}>
          <ContactLink />
        </Col>
      </Row>
    </Container>
  );
};

Onboarding.propTypes = {
  isUserLogin: PropTypes.func,
  history: PropTypes.object.isRequired,
};

export default withRouter(Onboarding);
